<script setup>
import InputError from '@/Components/InputError.vue';
// import PrimaryButton from '@/Components/PrimaryButton.vue';
import { onMounted, reactive, toRef, watch } from 'vue';
import { resetCheckout } from '../Welcome';
// import ArgumentsBeforeSubscription from '@/Components/Partners/Meditbe/ArgumentsBeforeSubscription.vue';

import { trans, transChoice } from 'laravel-vue-i18n';


const _props = defineProps({
    debug: { type: Boolean, default: false },
    //
    offering: { type: Object, },
    success_url: { type: String },
    cancel_url: { type: String },
    //
    route_checkout: { type: String },
    //
    updateSubscription: { type: Function },
    reloadOffering: { type: Function },
    subscription: { type: Object },
    has_local_coupon: { type: Boolean, default: false },
    has_stripe_coupon: { type: Boolean, default: false },
    show_stripe_offers: { type: Boolean, default: false },
    payment_labels: { type: Object },
    //
    layout: { type: Object },
});

import {
    offering,
    subscription,
    updateSubscription,
    reloadOffering,
    stripe_price_id,
    form,
    number_format,
    submit,
    buildLabels,
    sortable,
    buildPrices,
    priceRecurringIntervalToFr,
    getDuration,
    defaultLookupKey,
    applyPromoPercent,
    applyPromoFixe,
    has_local_coupon,
    has_stripe_coupon,
    show_stripe_offers,
    payment_label,
    payment_labels,
    emit,
    isProcessing,
    labels, // debug
} from '../CheckoutForm';

subscription.value = toRef(_props.subscription).value;
const _emit = defineEmits(['updateSubscription', 'reloadOffering']);

const init = (without_checkout) => {
    offering.value = _props.offering;
    subscription.value = _props.subscription;
    form.success_url = _props.success_url;
    form.cancel_url = _props.cancel_url;
    form.lookup_key = '';
    has_local_coupon.value = _props.has_local_coupon;
    has_stripe_coupon.value = _props.has_stripe_coupon;
    show_stripe_offers.value = _props.show_stripe_offers;
    payment_label.value = _props.payment_label;
    payment_labels.value = _props.payment_labels;
    emit.value = _emit;
    buildLabels();
    buildPrices();
    if (!without_checkout) {
        resetCheckout();
    }
    if (!route().current().startsWith('partners.partenamut')) {
        defaultLookupKey();
    }
}

onMounted(() => {
    init()
});

defineExpose({
    submit,
    defaultLookupKey,
    form,
    init
});
</script>
<template>

    <!-- <pre v-if="sortable && sortable.value" class="text-left text-green-700">sortable.value: {{ sortable.value }}</pre> -->

    <template v-if="debug">
        <!-- <pre class="mt-6 text-left text-red-600">subscription: {{ subscription }}</pre> -->
        <!-- <pre class="text-green-700">stripe_price_id: {{ stripe_price_id }}</pre> -->
        <!-- <pre class="text-left text-orange-700">props: {{ props }}</pre> -->
        <!-- sortable (1) ? -->
        <!-- <pre v-if="sortable && sortable.value" class="text-left text-green-700">sortable.value: {{ sortable.value }}</pre> -->
        <!-- <pre v-if="sortable && sortable.value" class="text-left text-green-700">Object.values(sortable.value): {{ Object.values(sortable.value) }}</pre> -->
        <!-- <pre v-if="sortable && sortable.value" class="text-left text-pink-700">sortable...price_id: {{ Object.values(sortable.value)[0].stripe.id }}</pre> -->
        <!-- <pre class="text-left text-purple-700">offering: {{ offering }}</pre> -->
        <!-- <pre v-if="offering.value.promotional"
                class="text-left text-orange-700">offering.value.promotional: {{ offering.value.promotional }}</pre> -->
        <!-- <pre class="text-left text-green-700">Object.keys(offering.packages.items): {{ Object.keys(offering.packages.items) }}</pre> -->

        <!-- <pre v-if="labels" class="text-left text-pink-700">labels: {{ labels }}</pre> -->

        <!-- <pre class="text-left">prices: {{ prices }}</pre> -->
        <!-- <pre class="text-left">form: {{ form }}</pre> -->
        <!-- <pre class="text-left">payment_labels: {{ payment_labels }}</pre> -->
        <!-- <pre class="text-left">isProcessing(): {{ isProcessing() }}</pre> -->
    </template>

    <form @submit.prevent="submit()" class="text-center">

        <div v-if="subscription.app_user_coupon_stripe && subscription.label" class="pb-8">
            <div class="font-semibold" v-html="subscription.label"></div>
            <div v-if="has_local_coupon || has_stripe_coupon" class="mt-2">
                <a href="#" @click="updateSubscription('app_user_coupon', ''), updateSubscription('app_user_coupon_stripe', '')" class="mt-2 inline-flex underline text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:focus:ring-offset-gray-800">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mt-0 mr-1">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9.75L14.25 12m0 0l2.25 2.25M14.25 12l2.25-2.25M14.25 12L12 14.25m-2.58 4.92l-6.375-6.375a1.125 1.125 0 010-1.59L9.42 4.83c.211-.211.498-.33.796-.33H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-9.284c-.298 0-.585-.119-.796-.33z" />
                    </svg>
                    {{ trans('Saisir un autre coupon') }}
                </a>
            </div>
        </div>

        <div class="flex flex-wrap flex-col sm:flex-row items-center sm:items-start justify-around gap-5 sm:gap-5">

            <!-- Loading is processing -->
            <div v-show="isProcessing('coupon')">
                <div class="w-full sm:w-auto flex flex-col items-center">
                    <label class="w-full sm:w-auto p-3 sm:p-4 z-0 scale-100 transition-all duration-250 rounded-2xl bg-white dark:bg-[#1D2F33] border-2">
                        <div class="flex sm:block">
                            <div class="whitespace-nowrap sm:relative sm:-mt-8 py-4 sm:py-1 px-4 rounded-lg bg-amber-200 mr-auto md:mx-auto text-sm text-white font-bold">
                                ...
                            </div>
                            <div>
                                <div class="grow whitespace-nowrap mt-2 ml-2 leading-relaxed text-3xl font-extrabold dark:font-bold text-[#eee] dark:text-white mx-auto">
                                    -,-- €
                                </div>
                            </div>
                        </div>
                    </label>
                </div>
            </div>

            <!-- Loading is complete -->
            <div v-show="!isProcessing('coupon')" v-for="(price) in sortable.value" :class="{
        'w-full flex flex-col content-center': true,
        'sm:flex-1': price.position != 3,
        'sm:flex-initial': price.position == 3,
    }">
                <template v-if="price.stripe">

                    <input :id="price.stripe['id']" type="radio" :value="price.stripe['id']" name="lookup_key" v-model="form.lookup_key" class="hidden peer" :disabled="isProcessing()" required @change="form.clearErrors()" />

                    <label :for="price.stripe['id']" :data-id="price.stripe['id']" class="relative w-full sm:w-auto p-4 sm:p-4 z-0 scale-100 transition-all duration-250 rounded-2xl bg-white dark:bg-[#303D49] border-2" :class="{
        [`cursor-pointer hover:z-50 sm:motion-safe:hover:scale-[1.05] md:motion-safe:hover:scale-[1.1] hover:border-[${layout.colors.primary_color}] dark:hover:border-[${layout.colors.primary_color}] border-3`]: !isProcessing(),
        [`!border-[${layout.colors.primary_color}] dark:border-[#303D49]`]: form.lookup_key && form.lookup_key == price.stripe['id'] || price.position == 1,
        'border-white dark:border-[#303D49]': !form.lookup_key || form.lookup_key != price.stripe['id']
    }">

                        <div :class="{ 'flex flex-row-reverse items-center justify-between gap-x-4 sm:flex-col': true }">

                            <div v-if="subscription.app_user_coupon_stripe" class="sm:mt-2 sm:ml-2 leading-light flex-none flex flex-col items-end">
                                <div class="barred-price flex gap-2 items-center">
                                    <div v-if="!offering.value.promotional.product || offering.value.promotional.product.id == price.stripe['product']" class="leading-light line-through sm:text-xl font-extrabold dark:font-bold text-red-800 dark:text-white">
                                        {{ number_format(price.stripe['unit_amount'] / 100, 2, ',', ' ') }} €
                                    </div>
                                    <div v-if="!offering.value.promotional.product || offering.value.promotional.product.id == price.stripe['product']" class="p-1 leading-none rounded-md bg-cyan-50 text-cyan-600">
                                        <template v-if="subscription.app_user_coupon_stripe.coupon.percent_off">
                                            -{{ subscription.app_user_coupon_stripe.coupon.percent_off }} %
                                        </template>
                                        <template v-else-if="subscription.app_user_coupon_stripe.coupon.amount_off">
                                            -{{ subscription.app_user_coupon_stripe.coupon.amount_off / 100 }} €
                                        </template>
                                    </div>
                                </div>
                                <div :class="{ 'text-xl sm:text-3xl font-extrabold dark:font-bold': true, [`text-[${layout.colors.txt_default}]`]: true, 'dark:text-white': true }">
                                    <template v-if="!offering.value.promotional.product || offering.value.promotional.product.id == price.stripe['product']">
                                        <template v-if="subscription.app_user_coupon_stripe.coupon.percent_off">
                                            {{ number_format(applyPromoPercent(price.stripe['unit_amount'], subscription.app_user_coupon_stripe.coupon.percent_off) / 100, 2, ',', ' ') }}
                                            €
                                        </template>
                                        <template v-else-if="subscription.app_user_coupon_stripe.coupon.amount_off">
                                            {{ number_format(applyPromoFixe(price.stripe['unit_amount'], subscription.app_user_coupon_stripe.coupon.amount_off) / 100, 2, ',', ' ') }}
                                            €
                                        </template>
                                    </template>
                                    <template v-else>
                                        {{ number_format(price.stripe['unit_amount'] / 100, 2, ',', ' ') }} €
                                    </template>
                                </div>

                            </div>
                            <div v-else class="flex-none">
                                <div :class="{ 'sm:mt-2 sm:ml-2 leading-light text-xl sm:text-3xl font-extrabold dark:font-bold': true, [`text-[${layout.colors.txt_default}]`]: true, 'dark:text-white mx-auto': true }">
                                    {{ number_format(price.stripe['unit_amount'] / 100, 2, ',', ' ') }} €
                                </div>
                            </div>
                            <div class="text-lg font-bold sm:font-normal sm:text-sm text-left sm:text-center flex-auto">
                                <div v-if="price.position == 1" class="absolute -top-3 sm:-top-4 left-4 sm:left-0 w-full text-xs font-bold">
                                    <span class="inline-block bg-amber-200 py-1 sm:py-2 px-2 sm:px-3 rounded-md dark:text-[#1d2b33]">
                                        {{ trans('Notre meilleure offre') }}
                                    </span>
                                </div>
                                <template v-if="price.stripe['type'] == 'recurring'">
                                    {{ priceRecurringIntervalToFr(price.stripe['recurring']['interval_count'], price.stripe['recurring']['interval']) }}
                                </template>
                                <template v-else>
                                    <template v-if="price.stripe">
                                        {{ getDuration(price.stripe) }}
                                    </template>
                                    <template v-else>
                                        {{ price.product.display_name }}
                                    </template>
                                </template>
                            </div>
                            <!-- <div class="flex-none">{{ price.position }}</div> -->
                        </div>
                    </label>

                    <template v-if="debug">
                        <pre class="mt-4 text-orange-700">{{ price.stripe['id'] }}</pre>
                    </template>

                </template>
                <template v-else>
                    <div class="my-4 font-semibold text-red-700 dark:text-red-300">
                        <!-- Stripe element is missing: -->
                        <span class="inline-flex align-bottom">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                            </svg>
                        </span>
                        {{ price.product.store_identifier }}
                    </div>
                </template>
            </div>

        </div>

        <InputError class="mt-6" :message="form.errors.lookup_key" />
        <InputError class="mt-6" :message="form.errors.app_user_id" />
        <Transition>
            <InputError v-if="subscription.app_user_id && form.errors.entitlement_already_subscribed" class="mt-2" :message="trans('Vous avez déjà un abonnement en cours pour cette période.')" />
        </Transition>

        <!-- <div class="mt-10"> -->
        <!-- <PrimaryButton type="submit" :class="{ 'opacity-25': isProcessing() }" :disabled="isProcessing()"> -->
        <!--<template v-if="sortable || Object.keys(sortable.value).length == 1">
                    Choisir une offre
                </template>
                <template v-else>-->
        <!-- Valider mon choix -->
        <!--</template>-->
        <!-- </PrimaryButton> -->
        <!-- </div> -->

    </form>
</template>